module.exports = __webpack_public_path__ + "img/img22.5577ee92.svg";